import { SET_LOGIN, SET_USER } from './types'

const initialState = {
    isLogin: false,
    user: {}
}

export default (state = initialState, action) => {
    switch(action.type) {
        case SET_LOGIN :
            return { ...state, isLogin: action.payload }
        case SET_USER :
            return { ...state, user: action.payload}
        default: 
            return state
    }
}




// WEBPACK FOOTER //
// ./src/redux/login/reducer.js